import {useEffect} from "react";
import {useLocation} from "react-router";

export const ScrollToTop = () => {
    const {pathname, hash} = useLocation();

    useEffect(() => {
        // If there's no hash anchor (e.g. #om-kurset), scroll directly to top
        if (!hash) {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return null;
};
